import React from 'react';
import { DDQr, WXQr } from './config'
import { hostMap, getHost, getLogoutUrl, goLogout, goLogin, requestCtrl, offlineUser, showProtocol } from './exportUtil'
import { exportPPT } from './exportPPT'
import vmsService from './vmsService';

const _window = (window as any)

_window.DDQr = DDQr
_window.WXQr = WXQr
_window.exportPPT = exportPPT

_window.textInfoMap = {
  '热度指数': '根据艺人在搜索、社交等各场的热度情况综合计算所得，代表全网热度指数，每日更新。',
  '社交指数': '艺人在核心社交场的综合热度指数，每日更新。',
  '热度斜率': '艺人在选定时间范围内的热度上升/下降趋势程度，每日更新。',
  '当前热度指数': '根据艺人在搜索、社交等各场的热度情况综合计算所得的最近一天的全网热度指数，每日更新。',
  '日均热度指数': '艺人在选定时间范围内根据搜索、社交等各场的热度情况综合计算所得的全网热度指数日均值，每日更新。',
  '商业指数': '根据艺人热度指数、带货表现、粉丝影响、代言水平、潜力表现综合计算所得，代表艺人的商业表现，每日更新。',
  // '全网热度': '根据艺人在搜索、社交等各场的热度情况综合计算所得，代表全网舆情热度，每日更新。',
  '预测热度指数': '根据艺人待播作品的预计播出时间和作品预估影响力，预测给艺人带来的全网热度变化，最长可预测未来3个月数据，每日更新。',
  '近三月商业指数': '根据艺人热度指数、带货表现、粉丝影响、代言水平、潜力表现综合计算所得，代表艺人近三月的商业表现，每日更新。',
  '热度': '艺人全网热度指数水平的指数化表达。',
  '带货力': '艺人带货能力的指数化表达。',
  '品牌力': '艺人商务代言能力的指数化表达。',
  '潜力值': '艺人预测热度的指数化表达。',
  '粉丝力': '艺人粉丝综合影响力水平的指数化表达。',

  '条均互动数': '选定时间段内发文内容的平均互动数，下方箭头表示和上一时间段相比的数据变化。',
  '条均转发数': '选定时间段内发文内容的平均转发数，下方箭头表示和上一时间段相比的数据变化。',
  '条均评论数': '选定时间段内发文内容的平均评论数，下方箭头表示和上一时间段相比的数据变化。',
  '条均点赞数': '选定时间段内发文内容的平均点赞数，下方箭头表示和上一时间段相比的数据变化。',
  '发文频率': '选定时间段内平均每天的发文数量。',
  '作品数': '选定时间段内的发文数量。',

  '粉丝画像': '粉丝画像是艺人社交平台上的粉丝群体画像',

  '品牌热度指数': '根据品牌在搜索、社交等各场的热度情况综合计算所得，代表全网热度指数，每日更新。',
  '品牌社交指数': '品牌在核心社交场的综合热度指数，每日更新。',
  '作品热度指数 - 累计': '当前统计周期内上映的影人在该品类下的相关作品（番位前4），在90天热播期对应的日均热度指数加和（按人物重要权重计算）。',
  '作品热度指数 - 剧均': '当前统计周期内上映的影人在该品类下的相关作品（番位前4），在90天热播期对应的日均热度指数加和除以相关作品数量。',
  '雷达图': <div>
    <div>热力值：艺人全网热度指数水平的指数化表达。</div>
    <div>带货力：艺人带货能力的指数化表达。</div>
    <div>品牌力：艺人商务代言能力的指数化表达。</div>
    <div>潜力值：艺人预测热度的指数化表达。</div>
    <div>粉丝力：艺人粉丝综合影响力水平的指数化表达。</div>
  </div>,
  '兄弟品牌': '同一母品牌下的其他子品牌',
};

_window.hostMap = hostMap
_window.getHost = getHost
_window.logoutUrl = getLogoutUrl()
_window.goLogout = goLogout
_window.goLogin = goLogin
_window.requestCtrl = requestCtrl
_window.offlineUser = offlineUser
_window.showProtocol = showProtocol


_window.userData = {}
_window.needSignedAgreement = false // 是否需要弹出协议
_window.isLogin = false
_window.userType = 2 // 1 内部 2 外部
_window.trialAccount = 1 // 0 正常账号 1 试用账号
_window.businessType = null // null内部 1 艺人 2 品牌 3 通用
_window.isRequestUserType = false
_window.requestUserTypePromise = null
_window.requestUserPromise = null

export const getAccountStatus = () => {
  if (_window.requestUserPromise) {
    return _window.requestUserPromise
  }
  const userInfo = {
    empId: null,
    name: null,
    nickName: null,
  }
  let userData: any = {}
  _window.requestUserPromise = vmsService.getAccountStatus().then((data) => {
    if (data && data.data) {
      userData = data.data || {}
      _window.userData = userData
      _window.isRequestUserType = true
      _window.isLogin = true
      _window.userType = userData.accountType || 2
      _window.trialAccount = userData.trialAccount === 0 ? 0 : 1
      _window.businessType = userData.businessType || null
      _window.needSignedAgreement = userData.needSignedAgreement
      userInfo.empId = userData.empId || null
      userInfo.name = userData.name || null
      userInfo.nickName = userData.nickName || null
      // _window.userType = 2

      const pid = _window.abf_aes_pid || 'Cynmek'
      if (_window.userType === 1) {
        _window.YseraTracker?.init({
          aemId: pid,
          pid,
          userType: 14, // 登录账号类型,参考: https://dip.alibaba-inc.com/pages/schemas/112963
          uid: userInfo.empId,
          username: userInfo.nickName || userInfo.name,
        });
      } else {
        _window.YseraTracker?.init({
          aemId: pid,
          pid,
          userType: 101, // 登录账号类型,参考: https://dip.alibaba-inc.com/pages/schemas/112963
          uid: userData.moziAccountId,
          username: userData.moziAccountId,
        });
      }
    }
    return {
      isLogin: _window.isLogin,
      userType: _window.userType,
      trialAccount: _window.trialAccount,
      businessType: _window.businessType,
      needSignedAgreement: _window.needSignedAgreement,
      userInfo,
      userData,
    }
  }).catch((err) => {
    if (err.message && err.message.indexOf('[-4]') !== -1) {
      _window.isLogin = true
      return {
        isLogin: _window.isLogin,
        userType: _window.userType,
        trialAccount: _window.trialAccount,
        businessType: _window.businessType,
        needSignedAgreement: _window.needSignedAgreement,
        userInfo,
        userData,
      }
    }
    if (err.message === '未登录') {
      _window.isLogin = false
      return {
        isLogin: _window.isLogin,
        userType: _window.userType,
        trialAccount: _window.trialAccount,
        businessType: _window.businessType,
        needSignedAgreement: _window.needSignedAgreement,
        userInfo,
        userData,
      }
    }
    console.error(err)
    throw err
  })
  return _window.requestUserPromise
}
_window.getAccountStatus = getAccountStatus

export const getUserType = () => {
  if (_window.requestUserTypePromise) {
    return _window.requestUserTypePromise
  }
  _window.requestUserTypePromise = getAccountStatus().then(({ userType }) => {
    return userType
  })
  return _window.requestUserTypePromise
}
_window.getUserType = getUserType

_window.authMap = {}
_window.isRequestAuth = false
_window.requestAuthPromise = null
const authCode = [
  'yk_xingyuan_pro',              // 星源高级版
  'yk_xingyuan_person_risk',      // 星源艺人舆情普通版
  'yk_xingyuan_person_risk_pro',  // 星源艺人舆情高级版
  'yk_xingyuan_ppt',              // 星源艺人PPT下载权限
]
export let canSwitchPro = false
export const localStorageKey = 'starProKey'
function getStarPro() {
  if (canSwitchPro) {
    const open = localStorage.getItem(localStorageKey)
    if (open === 'closePro') {
      return false
    }
    return true
  }
  return false
}
function setStarPro(open) {
  localStorage.setItem(localStorageKey, open ? 'openPro' : 'closePro')
}
function getAuthPro() {
  const isPro = getStarPro()
  _window.authMap.yk_xingyuan_pro = isPro
  if (!isPro) {
    _window.authMap.yk_xingyuan_person_risk_pro = false
  }
}
export const reload = () => {
  setTimeout(() => {
    window.location.reload()
  }, 0)
}
export const setAuthPro = (open) => {
  setStarPro(open)
  reload()
}
export const aclCheck = () => {
  if (_window.requestAuthPromise) {
    return _window.requestAuthPromise
  }
  const requestAuthPromise = vmsService.aclCheck(authCode).then((data) => {
    if (data && data.data) {
      authCode.forEach((code) => {
        _window.authMap[code] = data.data[code] || false
      })
      canSwitchPro = data.data.yk_xingyuan_pro || false
      if (canSwitchPro) {
        getAuthPro()
      }
      _window.isRequestAuth = true
    }
    return { ..._window.authMap }
  }).catch((err) => {
    console.error(err)
    throw err
  })
  _window.requestAuthPromise = requestAuthPromise
  return requestAuthPromise
}
_window.aclCheck = aclCheck
